//!!!!! TODO: Do not mutate state directly fix it asap!!!!!!
import React, {Component} from 'react'
import Reflux from 'reflux'
import Store from '../../../store/store'
import i18 from '../../../i18'
import api from '../../../source/api'
import PATH from '../../../config/dev'
import NotificationSystem from 'react-notification-system'
import {Link} from 'react-router-dom'
import moment from 'moment'

const STEPS_COUNT = 3;

class DownloadXml extends Reflux.Component {

    constructor(props) {
        super(props);
        this._notificationSystem = null;
        this.state = {
            company: props.company,
            invoices: props.invoices,

            insuficientcredit: false,
            cashDownloadButtonClicked: false,
            transferDownloadButtonClicked: false,
            forceTransferDownloadButtonClicked: false,
            enableModuleLog: true,

        };
        this.store = Store
    };

    componentDidMount = () => {
        window.scrollTo(0, 0);
        this._notificationSystem = this.refs.notificationSystem;
    };

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            invoices: nextProps.invoices,
            company: nextProps.company,
        });
    };

    _addNotification = (msg, type, time = 4) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: 'tc',
            autoDismiss: time
        });
    };

    download = (type) => {
        let data = {
            invoices: this.state.invoices,
            enableModuleLog: this.state.enableModuleLog,
            type: type,
        };

        document.body.classList.toggle('loading-body', true);
        api.post({url: 'supplier/steps/download?company_id=' + this.state.company.id, data: data}, true).then((response) => {
            document.body.classList.remove('loading-body');

            if (!response.data.url) {
                this.setState({insuficientcredit: true})
                return;
            }

            this.props.hideStepsMenu();

            if (type === 'cash') {
                this.setState({cashDownloadButtonClicked: true})
            }
            if (type === 'supplier') {
                this.setState({transferDownloadButtonClicked: true})
            }
            if (type === 'force_supplier') {
                this.setState({forceTransferDownloadButtonClicked: true})
            }

            window.open(PATH.ENDPOINT_BASE_URL + 'supplier/xml/get'
                + '?auth_token=' + api.getToken()
                + '&company_id=' + this.state.company.id
                + '&name=' + response.data.url
            )
        }).catch((err) => {
            console.log(err);
            document.body.classList.remove('loading-body');
            this._addNotification(err.response.data.error.message, 'error');
        });
        this.setState({enableModuleLog: false});
    };

    render() {
        return (
            <section id='supplier-assignment'>
                <div className='col-12'>
                    <br/>
                    <br/>
                    <h4>{i18.COMMON._processedSuccessfully}</h4>
                    <br/>

                    {this.state.insuficientcredit
                        ? <div className='text-center'>
                            <h1>Önnek nincs elegendő egyenlege a kimeneti fájlok letöltéséhez. <br/> Kérjük töltse fel egyenlegét.</h1>
                        </div>
                        : <div className='text-center'>

                            {!this.state.cashDownloadButtonClicked
                            && !this.state.forceTransferDownloadButtonClicked
                                ? <a onClick={(type) => this.download('cash')} className='green-btn uppercase margin-bottom-50'>Letöltés - Készpénz</a>
                                : <a className='green-btn uppercase margin-bottom-50 disabled'>Letöltés - Készpénz</a>
                            }&nbsp;&nbsp;

                            {!this.state.transferDownloadButtonClicked
                            && !this.state.forceTransferDownloadButtonClicked
                                ? <a onClick={(type) => this.download('supplier')} className='green-btn uppercase margin-bottom-50'>Letöltés - Szállító</a>
                                : <a className='green-btn uppercase margin-bottom-50 disabled'>Letöltés - Szállító</a>
                            }&nbsp;&nbsp;

                            {!this.state.forceTransferDownloadButtonClicked
                            && !this.state.cashDownloadButtonClicked
                            && !this.state.transferDownloadButtonClicked
                                ? <a onClick={(type) => this.download('force_supplier')} className='green-btn uppercase margin-bottom-50'>Letöltés - Minden szállító</a>
                                : <a className='green-btn uppercase margin-bottom-50 disabled'>Letöltés - Mindent szállítóként</a>
                            }&nbsp;&nbsp;

                            {this.state.cashDownloadButtonClicked
                            || this.state.transferDownloadButtonClicked
                            || this.state.forceTransferDownloadButtonClicked
                                ? <div className='margin-top-50'>
                                    <Link to="/">Új feldolgozás indítása</Link>
                                </div>
                                : null
                            }
                        </div>
                    }
                    <NotificationSystem ref='notificationSystem'/>
                </div>
            </section>
        );
    };
}

export default DownloadXml;


// WEBPACK FOOTER //
// ./src/components/supplier/steps/downloadxml.js